import { Navigate, useParams } from 'react-router-dom'

/** 旧的租户用量详情页 `/platform/ai-usage/tenants/:id` → Breakdown（按租户）并直接打开这个租户的 flyout。 */
export function PlatformAiUsageTenantRedirect() {
  const { tenantId = '' } = useParams()
  return <Navigate to={`/platform/ai-usage?tab=breakdown&dim=tenant&open=${encodeURIComponent(tenantId)}`} replace />
}
